// extracted by mini-css-extract-plugin
export default {"overlay":"ImagePreview_overlay__X7s02","modal":"ImagePreview_modal__snKRm","image":"ImagePreview_image__ccb7Z","zoomIn":"ImagePreview_zoomIn__2GAt8"};